import { useTranslation } from "react-i18next";
import { WinnerDocumentationRule } from "../../../autogen/bff-api";

export const useWinnerDocumentationTexts = (rule: WinnerDocumentationRule | undefined) => {
  const { t } = useTranslation();
  if (rule === WinnerDocumentationRule.Foa1715) {
    return {
      heading: (suppliers: string) =>
        suppliers
          ? t("Up-to-date documentation evidence from {{suppliers}}", { suppliers })
          : t("Up-to-date documentation evidence from the chosen supplier"),
      beforeAward: t(
        "Before you confirm the award, require the chosen supplier to submit up-to-date documentation evidence at once, and check it (FOA § 17-1 (5)).",
      ),
      statement: (suppliers: string) =>
        t("I have obtained and checked up-to-date documentation evidence from {{suppliers}} (FOA § 17-1 (5)).", {
          suppliers,
        }),
    };
  }
  return {
    heading: (suppliers: string) =>
      suppliers
        ? t("Up-to-date qualification documentation from {{suppliers}}", { suppliers })
        : t("Up-to-date qualification documentation from the chosen supplier"),
    beforeAward: t(
      "Before you confirm the award, obtain up-to-date documentation of the qualification requirements from the chosen supplier and check it (FOA § 8-10 (2)).",
    ),
    statement: (suppliers: string) =>
      t(
        "I have obtained and checked up-to-date documentation of the qualification requirements from {{suppliers}} (FOA § 8-10 (2)).",
        { suppliers },
      ),
  };
};
